export enum QuickBooksConnectionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
}

export enum QuickBooksTrackingCategoryStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

export enum QuickBooksSyncStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  PARTIAL = 'PARTIAL',
  FAILED = 'FAILED',
}

export enum QuickBooksSyncStage {
  LOADING_TRANSACTIONS = 'LOADING_TRANSACTIONS',
  MAPPING = 'MAPPING',
  SYNCING_TRANSACTIONS = 'SYNCING_TRANSACTIONS',
  SYNCING_ATTACHMENTS = 'SYNCING_ATTACHMENTS',
}

export enum QuickBooksSyncedTransactionStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

/**
 * Tracks the pipeline run state
 */
export type QuickBooksPipelineData = {
  stages: {
    [QuickBooksSyncStage.LOADING_TRANSACTIONS]: {
      status: QuickBooksSyncStatus
      issue?: string
    }
    [QuickBooksSyncStage.MAPPING]: {
      status: QuickBooksSyncStatus
      issue?: string
    }
    [QuickBooksSyncStage.SYNCING_TRANSACTIONS]: {
      status: QuickBooksSyncStatus
      issue?: string
      syncedTransactions: {
        transactionId: string
        qboPurchaseId?: string
        qboPurchaseUrl?: string
      }[]
    }
    [QuickBooksSyncStage.SYNCING_ATTACHMENTS]: {
      status: QuickBooksSyncStatus
      issue?: string
      syncedAttachments: {
        transactionId: string
        attachments: {
          id: string
          synced: boolean
        }[]
      }[]
    }
  }
}
